/* eslint-disable */
import axios from 'axios'
import Cookies from 'js-cookie'
import { Message } from 'element-ui'

// FIXME 临时测试接口添加cookie认证
// if(process.env.NODE_ENV !== 'production') {
Cookies.set('default', 'e17e7995-2651-4b7e-9aea-169941267a66')
// }
// 生产平台接口
const PRODUCTION_APIS = [
  'magazine',
  'work',
  'article',
  'book',
  'common',
  'index',
  'userCenter',
  'upload',
  'importArticle',
  'resource',
  'comparisonversion',
  'newUI',
  'huibian',
  'org',
  'tache',
  'multi',
  'rc-production'
]
// 运营平台magazine为首的APIS
const MAGAZINE_OPERATION_APIS = [
  'magazine/checkparam',
  'magazine/findMagazineById',
  'magazine/update',
  'magazine/gettemplatelist',
  'magazine/saveorupdaterevisionsetting',
  'magazine/getrevisionsettinginfo',
  'magazine/getGroupByMagazineId',
  // 管理中心
  'magazine/getPortalMagazineMenu',
  'magazine/getOrgNewVersion',
  'org/portalUser',
  'multi',
  'multi/article/',
  '/operate/notice'
]
const yyptApiCludes = [
  '/org/portalUser',
  // '/magazine/getPortalMagazineMenu',
  // '/magazine/getGroupByMagazineId',
  '/magazineMessage/',
  '/multi/',
  '/operate/notice',
  '/rc-manager/'
]
const _axios = axios.create({
  baseURL:
    typeof PROJECT_CONFIG !== 'undefined' &&
    typeof PROJECT_CONFIG.BASE_URL !== 'undefined'
      ? PROJECT_CONFIG.BASE_URL
      : '', // api的base_url
  timeout: 600000 // request timeout
  // headers: {'Content-Type': 'multipart/form-data'},
})
const domain = '.' + document.domain.split('.').slice(-2).join('.')

const userInfo = sessionStorage.getItem('userInfo')
  ? JSON.parse(sessionStorage.getItem('userInfo'))
  : null

// 为解决ie11 get请求不刷新页面问题
_axios.interceptors.request.use((config) => {
  if (process.env.NODE_ENV !== 'production') {
    let token =
      // 170
      // 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJpVHlTZ3pQUC1idEY5YkRzT3VNdXU2MXpidktxcWg5NGxMNkMyUnBTeVBZIn0.eyJleHAiOjE3MzcxMDU0NDAsImlhdCI6MTczNzA5ODI0MCwiYXV0aF90aW1lIjoxNzM3MDk4MjQwLCJqdGkiOiI4M2Q2ZjA5YS0wYTdkLTQzNTItYTNlOC03NzUyMWUyZjM0MTMiLCJpc3MiOiJodHRwczovL2pvdXJuYWwuaWRzLnN0YWdleC5menl1bi5pby9hdXRoL3JlYWxtcy9qb3VybmFsIiwiYXVkIjpbImpvdXJuYWwtcG9ydGFsdGVzdCIsImpvdXJuYWwtY29udHJpYnV0aW5nIiwiam91cm5hbC1zeWZqIiwiYWNjb3VudCJdLCJzdWIiOiJiZjI0MTZiNC00NmVlLTRmNTMtYTQ2ZS1lZjQ3ZjU5ZDAxZDAiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJqb3VybmFsLXBvcnRhbHRlc3QiLCJzZXNzaW9uX3N0YXRlIjoiMTYyODI1MGEtNzM3MC00NjNiLTk3YmQtMThjMWQ0M2E1NzA0IiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHA6Ly9tYWdhemluZS1pZHMucHVibGlzaC10ZXN0LmZvdW5kZXJzcy5jbiJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsib2ZmbGluZV9hY2Nlc3MiLCJkZWZhdWx0LXJvbGVzLWpvdXJuYWwiLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImpvdXJuYWwtY29udHJpYnV0aW5nIjp7InJvbGVzIjpbInZpc2l0b3IiXX0sImpvdXJuYWwtc3lmaiI6eyJyb2xlcyI6WyJ2aXNpdG9yIl19LCJqb3VybmFsLXBvcnRhbHRlc3QiOnsicm9sZXMiOlsidmlzaXRvciJdfSwiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCBwaG9uZSIsInNpZCI6IjE2MjgyNTBhLTczNzAtNDYzYi05N2JkLTE4YzFkNDNhNTcwNCIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6Iua1i-ivleS6jCIsInBob25lX251bWJlciI6IjE3NzIwMDAwMDAyIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiZnoxNzcyMDAwMDAwMiIsImxvY2FsZSI6InpoLUNOIiwiZmFtaWx5X25hbWUiOiLmtYvor5XkuowiLCJlbWFpbCI6IjE3NzIwMDAwMDAyQDE2My5jb20ifQ.a8qKmrdZYDDES-9aXIEH6wlC1sk1Gx6RdcF5UU8IBzILbhxGH3mVVWEPEyrt5ZwmYXK6EayF6TXabc8NQb8GzJh87shJc0IN-jArYIIZA2US6mlk7fbfu0gBzDdgPtYFIz4IBI7cInVzQB2z-L2kPCMKABEMlCyZ7PWoOTmpQou6joF_F1-Tm7J4Y0vNvzc3Cuu6PVcxCPFQi05Z0oY4tkulqPBYS1QoImmzh2kyYlKsSYUvif6uNGSyzsvKrp5l6bCPhvwkRMh91GOY0dx69z8-gft7lD8AcftsSnf2pzShh8Ab8uci2JlQ8WpIx2x69sOKI7UaXsZj-GZEH0FRKw'
      // 朱圣文020
      // 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJpVHlTZ3pQUC1idEY5YkRzT3VNdXU2MXpidktxcWg5NGxMNkMyUnBTeVBZIn0.eyJleHAiOjE3MzYzMjUyNzYsImlhdCI6MTczNjMxODA3NiwianRpIjoiYmZmM2JkMmItNTA2Ni00MTM3LWFhMGEtZTVjYmI5OTFmZDU5IiwiaXNzIjoiaHR0cHM6Ly9qb3VybmFsLmlkcy5zdGFnZXguZnp5dW4uaW8vYXV0aC9yZWFsbXMvam91cm5hbCIsImF1ZCI6ImpvdXJuYWwtY29udHJpYnV0aW5nIiwic3ViIjoiNDM2NjJkNmMtZmFmZi00ZmFhLWJiMzktY2FiMjAxOTQwMTcwIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiam91cm5hbC1jb250cmlidXRpbmciLCJzZXNzaW9uX3N0YXRlIjoiMzEwNDAwM2MtN2QzMC00MDJiLWFhYmYtZTYxNGFiMDA2ODRjIiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHA6Ly9jb250cmlidXRpbmcudGVzdC5wb3J0YWwtdGVzdC5mb3VuZGVyc3MuY24iXSwicmVzb3VyY2VfYWNjZXNzIjp7ImpvdXJuYWwtY29udHJpYnV0aW5nIjp7InJvbGVzIjpbInZpc2l0b3IiXX19LCJzY29wZSI6InByb2ZpbGUgZW1haWwgY2FzVXNlcklkIiwic2lkIjoiMzEwNDAwM2MtN2QzMC00MDJiLWFhYmYtZTYxNGFiMDA2ODRjIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJuYW1lIjoi5pyx5Zyj5paHMDIwIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiemh1c2hlbmd3ZW4wMjAiLCJsb2NhbGUiOiJ6aC1DTiIsImZhbWlseV9uYW1lIjoi5pyx5Zyj5paHMDIwIiwiZW1haWwiOiJzMTgzOTE4NTYxOTNAMTI2LmNvbSJ9.VdIkl0xfjENuRHzGHHU6H96HOcV-XfPDLxKTF3HODzYHMTHMdvmQ_gZZOeJ13BVLP-I0x3XeNwB_VELch16EzhAWT9He1eh7Uu8X0ocJcoQeuXWnqknk58lXWO50oCwR-MhF62G1jMMec-Pw6rDjtoS4GNrh1bl_txHVc2vVcuQsMdh-HafHmw09nUMZQP9-DcJBTPJfzWQ1ErxC5bA_IJgkbgwLqCjQ36RVuOjxRmQYFO2xijIcFGbiu5h3zhmjTtkxpOjg_7qzLY5GeMwSKFEhLQ9VCm_3n10FZmO649NzkoJoA5W6AFTGB1ZpRnz4MTskMwjqPrffw5Td3WMr7g'
      // zxh 测试环境
      `eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJpVHlTZ3pQUC1idEY5YkRzT3VNdXU2MXpidktxcWg5NGxMNkMyUnBTeVBZIn0.eyJleHAiOjE3NzMzNzE1MjgsImlhdCI6MTc3MzM3MTQ2OCwiYXV0aF90aW1lIjoxNzczMzcxNDY4LCJqdGkiOiJvbnJ0YWM6NzU1ZDY2OGUtMjFmYS1hODI4LTliYjUtZDZjM2U5Njc4YTE3IiwiaXNzIjoiaHR0cHM6Ly9qb3VybmFsLmlkcy5zdGFnZXguZnp5dW4uaW8vYXV0aC9yZWFsbXMvam91cm5hbCIsImF1ZCI6WyJqb3VybmFsLXBvcnRhbHRlc3QiLCJhY2NvdW50Il0sInN1YiI6IjFjYTVlYjdlLTlhMTQtNDAxMC1iNGJhLWNjZGM4ZTYzMDlhYyIsInR5cCI6IkJlYXJlciIsImF6cCI6ImpvdXJuYWwtcG9ydGFsdGVzdCIsInNpZCI6ImU3MDRmN2ZlLTAwOGQtMzg3Yi1iYzY5LTgxNTZjYmM3M2E4YyIsImFsbG93ZWQtb3JpZ2lucyI6WyJodHRwOi8vbWFnYXppbmUtaWRzLnB1Ymxpc2gtdGVzdC5mb3VuZGVyc3MuY24iXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbIm9mZmxpbmVfYWNjZXNzIiwidW1hX2F1dGhvcml6YXRpb24iXX0sInJlc291cmNlX2FjY2VzcyI6eyJqb3VybmFsLXBvcnRhbHRlc3QiOnsicm9sZXMiOlsidmlzaXRvciJdfSwiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCBwaG9uZSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6Iui1tea1t-asoiIsInBob25lX251bWJlciI6IjE4MzAxMzA4NzAwIiwicHJlZmVycmVkX3VzZXJuYW1lIjoienhoIiwibG9jYWxlIjoiemgtQ04iLCJmYW1pbHlfbmFtZSI6Iui1tea1t-asoiIsImVtYWlsIjoiemhhb2hoQGZvdW5kZXIuY29tLmNuIn0.UGcNm7QKSBGf5bPxKIZYMlSNHYVt4zfalgFZwdDt3FAEhWWalRHSnb3voSuPNVAY8pbi3tLBvVTILwd88oZqWNVHobHw9CnS5acKZUSSuM3Va9_OVWkTATN7AMBXCBySWs5mgbQcuBlZa7FxNU_an47898d86HCKEy6mGQNBxJ_NLQkLrSv4oziZQHWENGfgLXUTHKMKeYDCdHr6vFPSeSS-Hrf8EZ1dltaZ7anU_3dFBRTDxm59icp5v7QS-ydWgQI9I2qoGN2I-3qndkk6Y6_0cmIT28vdcrnWz5hL3eEZ8ggKC_7LxnwzPh_amTmkIdlAY3H6WDLeBsNL0MhcRg`
    // 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJpVHlTZ3pQUC1idEY5YkRzT3VNdXU2MXpidktxcWg5NGxMNkMyUnBTeVBZIn0.eyJleHAiOjE3MzE1NzU2ODcsImlhdCI6MTczMTU2ODQ4NywianRpIjoiN2FhM2IzNmItODkyMC00ODRlLWFmZTgtZTM5MTU4ZmMxNDczIiwiaXNzIjoiaHR0cHM6Ly9qb3VybmFsLmlkcy5zdGFnZXguZnp5dW4uaW8vYXV0aC9yZWFsbXMvam91cm5hbCIsImF1ZCI6ImpvdXJuYWwtY29udHJpYnV0aW5nIiwic3ViIjoiMWNhNWViN2UtOWExNC00MDEwLWI0YmEtY2NkYzhlNjMwOWFjIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiam91cm5hbC1jb250cmlidXRpbmciLCJzZXNzaW9uX3N0YXRlIjoiNGI3YWYwM2UtYWIzNi00ZmJlLWFkY2UtNmNjYWZmOTVlNjg2IiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHA6Ly9jb250cmlidXRpbmcudGVzdC5wb3J0YWwtdGVzdC5mb3VuZGVyc3MuY24iXSwicmVzb3VyY2VfYWNjZXNzIjp7ImpvdXJuYWwtY29udHJpYnV0aW5nIjp7InJvbGVzIjpbInZpc2l0b3IiXX19LCJzY29wZSI6InByb2ZpbGUgZW1haWwgY2FzVXNlcklkIiwic2lkIjoiNGI3YWYwM2UtYWIzNi00ZmJlLWFkY2UtNmNjYWZmOTVlNjg2IiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJuYW1lIjoi6LW15rW35qyiIiwicHJlZmVycmVkX3VzZXJuYW1lIjoienhoIiwibG9jYWxlIjoiemgtQ04iLCJmYW1pbHlfbmFtZSI6Iui1tea1t-asoiIsImVtYWlsIjoiemhhb2hoQGZvdW5kZXIuY29tIn0.YtRcq_NPID1W5vrPtOpIDZRIbGq8RnhV7M_xrIfwubLAGiu_3KoLsNS3-I37iWQSOHWJcKoT8wDDx0t_xKMMmqz5EPkdAWa9Qb7mq5dhoeLUPMXha_3Lajh6ks2m7bWrHMr9NouFLMYOq4slJvdGr-44S8NsR_VpeebNWMxqCQriBN3dZo9HHgvHnJRlLc0tYBKHR_O3j5aTfFS9AbFC7e1Uav7DPlVq25MwRsh-bvpQN8J81RhoUhY110uacIEWwCEgDLZ5C5CX9tIY8UI86bPqg-bWJzLBsD1qqjFGehjgt-iiBcqjiASGroMvx1PwRZi9wQBGFMw48eshsqin0A'
    // zhao123 开发环境
    // 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI4SUpLOWJzM0pRNUctcU5jd18wZkhJUHpWTWFqVTNYLXlTTkFfdGs5Y2ZBIn0.eyJleHAiOjE3Mjc4NjM5MTgsImlhdCI6MTcyNTM1ODMxOCwianRpIjoiYmJjZGNiNTktN2JiZS00MWVjLTkwZjYtYmMwNGU3NmE4MDlkIiwiaXNzIjoiaHR0cHM6Ly9xaWthbi5pZHMudGVzdHguZnp5dW4uaW8vYXV0aC9yZWFsbXMvcWlrYW4iLCJhdWQiOiJxaWthbi1wb3J0YWwiLCJzdWIiOiIzNTIyY2U2OC05ZTNlLTQyZmQtYTg0ZC01OTBhOWEyN2U3MWMiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJxaWthbi1wb3J0YWwiLCJzZXNzaW9uX3N0YXRlIjoiZjhkZWVmNWUtMWFkMy00MzQ1LTliNjAtZTVhODZhN2U3MzdlIiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHA6Ly9tYWdhemluZS1pZHMuZGV2Ni5menl1bi5pbyJdLCJyZXNvdXJjZV9hY2Nlc3MiOnsicWlrYW4tcG9ydGFsIjp7InJvbGVzIjpbInZpc2l0b3IiXX19LCJzY29wZSI6ImNhc1VzZXJJZCBwcm9maWxlIGVtYWlsIiwic2lkIjoiZjhkZWVmNWUtMWFkMy00MzQ1LTliNjAtZTVhODZhN2U3MzdlIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJuYW1lIjoi6LW15rW35qyiIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiemhhbzEyMyIsImZhbWlseV9uYW1lIjoi6LW15rW35qyiIiwiZW1haWwiOiJ6aGFvaGhAZm91bmZlci5jb20uY24ifQ.dcpG5UfgYduRwVCyJKwMUqCIW0pSKcfM-fCg1pQC1QNqgMXD8i2eBNyo7qQE1Uehs9G3YnJh9qltoVc3FqWUQ7c8aZODrT2V2yNWBNBdkH0qpl8ic6NrVfhcQMTLp2mrc8FPsfKuLp2dUjhrKV_PfhThbedXF8FxRnapCx_jy9qIS0Ir7MeDjVhNp9eQR7N3ibouud011HCd9T7C5VCzM9xa-fB9d-o4xKRUGnzeco62ACz5qPZpg9KTmoFAcXbtFJSUmsXbIFaiRTHwriOVa-ahp1k92Vki5aAxiq23O2Cu88XKEYv-i71EpH1cKHI88pD_8LFwt83SPw6fAlwMLQ'
    // guolinjing1 测试环境
    //'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJpVHlTZ3pQUC1idEY5YkRzT3VNdXU2MXpidktxcWg5NGxMNkMyUnBTeVBZIn0.eyJleHAiOjE2NjQ0MTgyMjcsImlhdCI6MTY2NDQxNjQyNywianRpIjoiOGVkNTgzYjgtM2YxNC00MzZlLThmYWEtOTM0ZmRhMTMwNWY2IiwiaXNzIjoiaHR0cHM6Ly9qb3VybmFsLmlkcy5zdGFnZXguZnp5dW4uY24vYXV0aC9yZWFsbXMvam91cm5hbCIsImF1ZCI6ImpvdXJuYWwtY29udHJpYnV0aW5nIiwic3ViIjoiNzBiOGI3YzQtYTM5MS00YmMxLTgzYjItNTA2NTc0NGE3YmNlIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiam91cm5hbC1jb250cmlidXRpbmciLCJzZXNzaW9uX3N0YXRlIjoiMDYxNmY3MzktMjAyYi00YjA2LWI4NTctZTZlN2E2YWQyZTA3IiwiYWNyIjoiMSIsImFsbG93ZWQtb3JpZ2lucyI6WyJodHRwOi8vY29udHJpYnV0aW5nLnRlc3QucG9ydGFsLXRlc3QuZm91bmRlcnNzLmNuIl0sInJlc291cmNlX2FjY2VzcyI6eyJqb3VybmFsLWNvbnRyaWJ1dGluZyI6eyJyb2xlcyI6WyJ2aXNpdG9yIl19fSwic2NvcGUiOiJwcm9maWxlIGVtYWlsIGNhc1VzZXJJZCIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6Imd1b2xpbmppbmcxIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiZ3VvbGluamluZzEiLCJmYW1pbHlfbmFtZSI6Imd1b2xpbmppbmcxIiwiZW1haWwiOiIyMjIwQHFxLmNvbSJ9.QEVN2ZiX-lyCd0k39RgOepRZxR4qi2l5dMo-EOe7D_SDEdzfQox6wJtqlcfDOScpmdcwHXVm2R5tYBwUuKxOFcYOUWg-dd0-dE-YJXHZTzI8w9vWCrjYA4CFoliac0aidsVCAtCOwVETXQpBR69eC9t8hop6WbCtmY3KKsK2fUb_jqLnJtVTr7XLo-D8Nkabmbo0fDwLCDGf_05p74z80KKvf53NpQilgAaP6zgWAXoJF7wQBwmapucH6VJHIHMdNF8bGDmQqCTwsd1N7oy6ptOealHXnMcdT4qy8IiQwn5HG1qAdy9stSqj5k9aFW0HfYvUoxAYJpVuxBPypRNySQ'
    // guolinjing2 测试环境
    // 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJpVHlTZ3pQUC1idEY5YkRzT3VNdXU2MXpidktxcWg5NGxMNkMyUnBTeVBZIn0.eyJleHAiOjE2NjIwMTgyODksImlhdCI6MTY2MjAxNjQ4OSwianRpIjoiYTllNjdmN2QtOGU3ZC00ZWNjLTliZGUtMGY4YmNmZmU1YWU1IiwiaXNzIjoiaHR0cHM6Ly9qb3VybmFsLmlkcy5zdGFnZXguZnp5dW4uY24vYXV0aC9yZWFsbXMvam91cm5hbCIsImF1ZCI6ImpvdXJuYWwtY29udHJpYnV0aW5nIiwic3ViIjoiMDJhMjExMjQtOGQ0My00OTc5LTkzZmItZDIzOWM2M2M2ZWRmIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiam91cm5hbC1jb250cmlidXRpbmciLCJzZXNzaW9uX3N0YXRlIjoiZjYyM2UzNmMtNWE5ZC00MzBhLWJlNGMtY2ViODc3ZGMyNWZiIiwiYWNyIjoiMSIsImFsbG93ZWQtb3JpZ2lucyI6WyJodHRwOi8vY29udHJpYnV0aW5nLnRlc3QucG9ydGFsLXRlc3QuZm91bmRlcnNzLmNuIl0sInJlc291cmNlX2FjY2VzcyI6eyJqb3VybmFsLWNvbnRyaWJ1dGluZyI6eyJyb2xlcyI6WyJ2aXNpdG9yIl19fSwic2NvcGUiOiJwcm9maWxlIGVtYWlsIGNhc1VzZXJJZCIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6Imd1b2xpbmppbmcyIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiZ3VvbGluamluZzIiLCJmYW1pbHlfbmFtZSI6Imd1b2xpbmppbmcyIiwiZW1haWwiOiJndW9saW5qaW5nMkBpdWdlLmNvbSJ9.YmLE8dktxET7iaRg4wYZtic4KfcyuSvbQweK4tImzo61zK0U5nzP4EPAemVabHBwCPuZBGsPd_UHsiU04v6nwL-_LCEfRC6T-usmgWmEuwxb2M0eVnQAc3iiZkLhhxKxFWAHyJGHlRO6i773BkRACfgsIkwE64Qd4EJ7a2GJPfD_d0qQgvL2-otNkfyCDClmUFiG05rBfCSkQIXt-_4ynlSgRVz8UwAHtm0kUhmidjT0w1q95Zig2SzlQLVfcbW51YmUMdWKjjqaeA0pWj0WzMDLrjsIEbnEDfzcogNdFPY9CFspb7Z_NCDcSU29VhZlrf91POMsm4Vcj8CM902puw'
    // 编审中心用户权限
    let JournalAuth =
      // 宫丽杰 开发环境
      'eyJhY2NvdW50bmFtZSI6ImNoZW50aW5ndGluZyIsImVtYWlsIjoiY2hlbnRpbmd0aW5nQGZvdW5kZXIuY29tIiwiaXNBZG1pbiI6ZmFsc2UsImpvdXJuYWxUeXBlIjoxLCJtYWdhemluZWNvZGUiOiJjZXNoaWNiIiwibWFnYXppbmVpZCI6IjYzOWI1NTBmNDg0NTQ4Njc5OWNmZjk1ZDZlOWVmZWU3IiwibWFnYXppbmVuYW1lIjoi5rWL6K+V546v5aKD6YeH57yW5YiK576kIiwidGVsZXBob25lIjoiMTgyODYxNDA2OTIiLCJ1c2VyaWQiOiIwMzY5ODM4NDlmZTc0YTA5OWRmOWU0MzgzYWQzZDFlZSIsInVzZXJuYW1lIjoi6ZmI5am35am3In0='
    // 'eyJleHAiOjE3MjczNTM2MTUsImlhdCI6MTcyNzM0NjQxNSwianRpIjoiMmRjYzE4ZDMtMWQ1NC00MTQxLTgwNzEtZTI1ODBjYmNmMTAzIiwiaXNzIjoiaHR0cHM6Ly9qb3VybmFsLmlkcy5zdGFnZXguZnp5dW4uaW8vYXV0aC9yZWFsbXMvam91cm5hbCIsImF1ZCI6ImpvdXJuYWwtY29udHJpYnV0aW5nIiwic3ViIjoiMWNhNWViN2UtOWExNC00MDEwLWI0YmEtY2NkYzhlNjMwOWFjIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiam91cm5hbC1jb250cmlidXRpbmciLCJzZXNzaW9uX3N0YXRlIjoiNWJlYjA0NDItYWVjOC00MDFhLTlmYTQtMGM0ZGE3ODY0NTllIiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHA6Ly9jb250cmlidXRpbmcudGVzdC5wb3J0YWwtdGVzdC5mb3VuZGVyc3MuY24iXSwicmVzb3VyY2VfYWNjZXNzIjp7ImpvdXJuYWwtY29udHJpYnV0aW5nIjp7InJvbGVzIjpbInZpc2l0b3IiXX19LCJzY29wZSI6InByb2ZpbGUgZW1haWwgY2FzVXNlcklkIiwic2lkIjoiNWJlYjA0NDItYWVjOC00MDFhLTlmYTQtMGM0ZGE3ODY0NTllIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJuYW1lIjoi6LW15rW35qyiIiwicHJlZmVycmVkX3VzZXJuYW1lIjoienhoIiwiZmFtaWx5X25hbWUiOiLotbXmtbfmrKIiLCJlbWFpbCI6InpoYW9oaEBmb3VuZGVyLmNvbSJ9'
    config.headers.Authorization = `Bearer ${token}`
    config.headers.JournalAuth = JournalAuth
  }
  config.headers.rcpub = sessionStorage.getItem('orgCode')
  // 给每个接口添加token, 如果token存在，赋值到headers,不能再外面定义，进入请求获取之后再获取token
  if (Cookies.get('commonToken', { path: '/', domain: domain })) {
    config.headers.token = Cookies.get('commonToken', {
      path: '/',
      domain: domain
    })
  }
  // 资源中心统一加刊物id和租户id
  if (config.url.indexOf('rc-api') === 1) {
    // Iszl 该值是为了区分，是否是总览页面，总览页面取当前刊的信息，列表带期刊切换的取切换刊的信息。
    // 如果列表页面没有期刊切换功能，等同于总览页面，需要本地存值Iszl = true，离开当前页面时删除该值
    let Iszl = sessionStorage.getItem('Iszl') === 'true' ? true : false
    let tenantId = Iszl
      ? sessionStorage.getItem('tenantId')
      : sessionStorage.getItem('checktenantId') ||
        sessionStorage.getItem('tenantId')
    let publicationId = Iszl
      ? sessionStorage.getItem('publicationId')
      : sessionStorage.getItem('checkpublicationId') ||
        sessionStorage.getItem('publicationId')
    let isGroupMag = Iszl
      ? sessionStorage.getItem('isGroup')
      : sessionStorage.getItem('checkIsGroup') ||
        sessionStorage.getItem('isGroup')
    let groupVal = JSON.parse(sessionStorage.getItem('isGroup'))
    let checkVal = JSON.parse(sessionStorage.getItem('checkIsGroup'))
    let fromGroup = groupVal ? (checkVal ? false : true) : false
    config.url = `${
      config.url
    }?publicationId=${publicationId}&tenantId=${tenantId}&isGroupMag=${isGroupMag}&timestamps=${new Date().getTime()}`
    if (!Iszl) {
      config.url = `${config.url}&fromGroup=${fromGroup}`
    }
    if (sessionStorage.getItem('siteId')) {
      config.headers['siteId'] = sessionStorage.getItem('siteId')
    }
  }

  // 发布中心统一加站点id
  if (config.url.indexOf('rc-pub') === 1 && sessionStorage.getItem('siteId')) {
    config.headers['siteId'] = sessionStorage.getItem('siteId')
  }

  for (let api of PRODUCTION_APIS) {
    if (
      config.url.indexOf(api) === 1 &&
      config.url.indexOf('/getAdvid') === -1
    ) {
      config.headers['orgCode'] = sessionStorage.getItem('orgCode')
      if (api === 'magazine' || api === 'org' || api === 'multi') {
        for (let oApi of MAGAZINE_OPERATION_APIS) {
          if (config.url.indexOf(oApi) !== -1) {
            config.headers['orgCode'] = 'magazinemanager'
            config.headers.portal = '77aaf908d3994a95bf4a8e3ca31851ea'
          }
        }
      }
    }
  }
  yyptApiCludes.forEach((item) => {
    if (config.url.indexOf(item) !== -1) {
      config.headers.portal = '77aaf908d3994a95bf4a8e3ca31851ea'
      config.headers.orgCode = 'magazinemanager'
    }
  })
  config.headers.operatorLoginName = userInfo && userInfo.loginName

  // 生产平台加机构code 、生产接口赋值orgCode
  // if (window.location.href.indexOf('productCenter') > 1) {
  //   config.headers['orgCode'] = sessionStorage.getItem('orgCode')

  //   // 数据核校相关接口
  //   if(config.url.indexOf('datacenter') !== -1){
  //     config.headers['orgCode'] = 'magazinemanager'
  //     config.headers.portal = '77aaf908d3994a95bf4a8e3ca31851ea'
  //   }
  // }

  // if (config.url.indexOf('/org/portalUser') !== -1 || config.url.indexOf('/magazine/getPortalMagazineMenu') !== -1) {
  //   config.headers.portal = '77aaf908d3994a95bf4a8e3ca31851ea'
  //   config.headers.orgCode = 'magazinemanager'
  // }

  if (config.method === 'get') {
    // 给get请求增加随机数
    if (config.params) {
      config.params.timestamps = new Date().getTime()
      if (config.params.identifyHeader) {
        config.headers.captcha = config.params.identifyHeader
      }
    } else {
      // 针对没参数的get请求特殊处理
      if (!config.url.indexOf('rc-api') === 1) {
        config.url = config.url + '?timestamps=' + new Date().getTime()
      }
    }
  }
  if (config.method === 'delete') {
    if (config.params && config.params.identifyHeader) {
      config.headers.captcha = config.params.identifyHeader
    }
  }
  return config
})
// respone interceptor
_axios.interceptors.response.use(
  (response) => {
    if (response.data.status === 401) {
      Message({
        message: response.data.message,
        type: 'error',
        duration: 2 * 1000
      })
      return
    } else {
      return response
    }
  },
  (error) => {
    let response = error.response
    // ids 那边token失效时，状态码 307
    if (
      response === 'undefined' ||
      response.status === 307 ||
      response.status === '307' ||
      (response.data && response.data.status === 307)
    ) {
      window.open('/oauth/logout', '_self')
    }
    return Promise.reject(error)
  }
)
var Get = _axios.get
var Post = _axios.post
var Put = _axios.put
var Delete = _axios.delete

export { Get, Post, Put, Delete }
